require("!!/data/app/rdc-next/node_modules/script-loader/addScript.js")(require("!!/data/app/rdc-next/node_modules/raw-loader/index.js!/data/app/rdc-next/node_modules/source-map-loader/index.js!/data/app/rdc-next/node_modules/readmore-js/readmore.js"))


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/readmore-js/readmore.js
// module id = 1045
// module chunks = 4 5